import { useState, useEffect } from "react";

interface NavbarProps {
  onNavigate: (id: string) => void;
}

export default function Navbar({ onNavigate }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Home", id: "home" },
    { label: "About", id: "about" },
    { label: "Resume", id: "resume" },
    { label: "Projects", id: "projects" },
    { label: "Contact", id: "contact" },
  ];

  const handleClick = (id: string) => {
    onNavigate(id);
    setMobileOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-off-white/95 backdrop-blur-sm border-b border-teal/25"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-12 lg:px-20 py-5 flex items-center justify-between">
        <button
          onClick={() => handleClick("home")}
          className="font-serif text-xl md:text-2xl text-charcoal tracking-wide cursor-pointer whitespace-nowrap group relative"
        >
          Jordan Duke
          <span className="hidden lg:inline font-sans text-[10px] uppercase tracking-[2px] text-warm-gray ml-3 align-middle">Interior Design</span>
          <span className="absolute -bottom-1 left-0 w-full h-[2px] bg-gradient-to-r from-teal/60 via-teal/30 to-transparent scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
        </button>

        <div className="hidden md:flex items-center gap-14">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => handleClick(link.id)}
              className="font-sans text-sm text-charcoal/80 hover:text-teal transition-colors duration-300 tracking-wide cursor-pointer whitespace-nowrap relative after:absolute after:-bottom-1 after:left-0 after:w-full after:h-[1px] after:bg-teal/50 after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:duration-300 after:origin-left"
            >
              {link.label}
            </button>
          ))}
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-charcoal cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i
            className={`ri-${mobileOpen ? "close" : "menu"}-line text-2xl`}
          />
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-off-white/95 backdrop-blur-sm border-t border-cream">
          <div className="px-6 py-6 flex flex-col gap-5">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => handleClick(link.id)}
                className="font-sans text-base text-charcoal/80 hover:text-terracotta transition-colors duration-300 text-left cursor-pointer"
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}